export const BottomSectionText = {
  pattern1:
    '專門留学・海外就職・ビザ取得・移民をご検討の方はお気軽にご相談ください',
  pattern2: 'LINEでのお問い合わせはこちらから',
  pattern3: `保育関連のお問い合わせは「ホイクぺディア」、クリエイター関連のお問い合わせは「Frog」の公式LINEより承っております。<br />なお、移民関連など上記以外のお問い合わせに関しては、お手数ですが通常の問い合わせフォームよりお問い合わせください。`,
};
